import clientConfig from "../../../../../template/clientConfig";

export const BounceEffect = !clientConfig.isServer()
  ? require("inobounce")
  : { enable: () => {}, disable: () => {} };



// WEBPACK FOOTER //
// ./template/state/modules/layout/helpers/bounceeffect.js